import React, { useState } from "react";
import { getContainer } from "../../ioc/IOCSetup";
import {
    AdminNote,
    User
} from "../../http/protocol";
import { AdminNotesService } from "../../services/AdminNotesService";
import { Form, FormListener } from "../form/Form";
import { FormGroup } from "../form/FormGroup";
import { Submit } from "../form/Submit";
import { FormTextArea } from "../form/FormTextArea";
import { UserActionContainerProps, UpdateActionStatus, UserActionContainer } from "./UserActionContainer";

export const UserComment: React.FC<UserActionContainerProps> = (props: UserActionContainerProps) => {

    const adminNotesService: AdminNotesService = getContainer().getAdminNotesService();
    const [form, setForm] = useState({ message: "" });

    function sendNote(user: User, comment: string) {
        let note: AdminNote = {
            type: "USER",
            typeId: "" + user.id,
            comment: comment || ""
        };
        return adminNotesService.save(note);
    }

    function submit() {
        let comment = form.message;
        if (!comment || comment.length < 1) return;
        let users = [...props.users || []];
        for (let i = 0; i < props.users!.length; i++) {
            users[i].status = UpdateActionStatus.PENDING;
            users[i].description = `Prepared to submit comment "${comment}"`;
            users[i].request = () => new Promise<{ status: string; description: string; response: any; }>(async (resolve, reject) => {
                try {
                    let response = await sendNote(users[i].user, comment);
                    resolve({ status: UpdateActionStatus.OK, description: `Submitted comment "${comment}"`, response: response });
                } catch (error) {
                    resolve({ status: UpdateActionStatus.FAIL, description: `Failed to submit comment "${comment}"`, response: error });
                }
            });
        }
        if (props.updateUsers) props.updateUsers(users);
        setForm({ message: "" });
    }

    const ref: FormListener<any> = {
        formDidUpdate: (formModel: any, validationMap: any) => {
            setForm(formModel);
        },
        onSubmit: () => { submit(); }
    };

    return (
        <UserActionContainer title={"User Comment"}>
            <Form className="form-horizontal" formListener={ref} modelObject={form} validationMap={{}}>
                <FormGroup className="form-group row">
                    <FormTextArea className={"form-control col-sm-12"} model="message" placeholder={"Enter your text"} />
                </FormGroup>
                <FormGroup className="form-group row">
                    <div className="col-sm-4">
                        <Submit className="btn btn-danger">Submit</Submit>
                    </div>
                </FormGroup>
                <FormGroup className="form-group row">
                    <span className={"help-block"}>A separate comment will be added to each user in the list.</span>
                    <span className={"help-block"}>The entered test will be removed after submission.</span>
                </FormGroup>
            </Form>
        </UserActionContainer>
    );

};
